import { useEffect, useState } from 'react';
import { useAppContext } from '../AppContext';
const StickyHeader = ({ childClass, children }) => {
    const [offsets, setOffsets] = useState(null);
    const [originalWidth, setOriginalWidth] = useState(0);
    const { isMobile } = useAppContext()
    useEffect(() => {
        const h1 = document.getElementsByTagName('header')[0];
        const h2 = document.querySelector(`.${childClass}`);
        const updateOffsets = () => {
            if (!offsets) {
                const h1offset = h1.getBoundingClientRect().top + window.scrollY;
                const h2offset = h2.getBoundingClientRect().top + window.scrollY;
    
                setOffsets([h1offset, h2offset]);
            }
        };

        const handleScroll = () => {
            const scrollHeight = window.scrollY;

            if (!h1 || !h2 || !offsets) return;

            const h1Height = h1.offsetHeight;
            const h2Height = h2.offsetHeight;


            if (offsets[0] <= scrollHeight && scrollHeight < offsets[1] -  h1Height) {
                h1.style.position = "fixed";
                h1.style.top = "0px";
                h1.style.width = "100%";


                h2.style.position = "unset";
                // h2.style.maxWidth = originalWidth;
                h2.style.left = 0;

                document.body.style.paddingTop = `${h1Height}px`;
            }
            else if (scrollHeight >= offsets[1] - h1Height && scrollHeight < offsets[1]) {
                h1.style.position = "fixed"; 
                h1.style.top = `${-(scrollHeight - (offsets[1] - h1Height))}px`;


                h2.style.position = "fixed";
                h2.style.maxWidth = "unset"
                h2.style.top = `${h1Height - (scrollHeight - (offsets[1] - h1Height))}px`;

                document.body.style.paddingTop = `${h1Height + h2Height}px`;
            }

            else if (scrollHeight >= offsets[1]) {
                h1.style.position = "static";

                h2.style.position = "fixed";
                h2.style.top = 0;

                document.body.style.paddingTop = `${h2Height}px`;
            }

            else {
                h1.style.position = "static";
                h1.style.top = 0;

                h2.style.position = "static";
                h2.style.top = 0;

                document.body.style.paddingTop = "0px";
            }
        };

        updateOffsets();

        if (!isMobile) {
            window.addEventListener('resize', updateOffsets);
            window.addEventListener('scroll', handleScroll);
        }

        return () => {
            window.removeEventListener('resize', updateOffsets);
            window.removeEventListener('scroll', handleScroll);
            document.body.style.paddingTop = "0px";
        };

    }, [offsets,childClass,isMobile,originalWidth]);

    useEffect(() => {
        const h2 = document.querySelector(`.${childClass}`);
        
        setOriginalWidth(getComputedStyle(h2).maxWidth);        
    } , [childClass]);


    return (
        <>
            {children}
        </>
    );
};

export default StickyHeader;

